/* eslint-disable indent */
/* eslint-disable no-unused-vars */

import React, { useState, useEffect, useRef, memo } from "react";

import { Form } from "antd";

import CPCreditBooking from "./CPCreditBooking";
import ClientCreditBooking from "./clientCredit";

import { formatReceiverAddress, splitReceiverName } from "../../../utils";

import { getCurretRole } from "../../../utils";
import axios from "axios";
import useClientAndDepartment from "./useClientAndDepartment ";

const isClientAdmin = getCurretRole();

function CreditBookingMain() {
  const [printer, setPrinter] = useState(null);

  useEffect(() => {
    const fetchPrinter = async () => {
      try {
        // STANDARD PORT FOR ZEBRA PRINTER
        const availablePrinters = await axios.get(
          "http://localhost:9100/available"
        );
        // console.log("availablePrinters: ", availablePrinters?.data?.printer[0]);
        setPrinter(availablePrinters?.data?.printer[0] || null);
        //  REQUEST TO INITIATE PRINTER
        await axios.post("http://localhost:9100/write", "", {
          headers: {
            "Content-Type": "text/plain",
          },
        });
      } catch (err) {
        // console.log("ZEBRA PRINTER NOT FOUND ");
      }
    };
    if (!printer) {
      fetchPrinter();
    }
  }, []);

  useEffect(() => {
    getContentDiscriptionData();
    // getRecvNameAddressList("Account");
    getFocusFirstInput("cashFirst");
    setTimeout(() => {
      window.scroll(0, 0);
    }, 100);
  }, []);
  const { userInfo } = JSON.parse(localStorage?.getItem("userId")) || "";
  // const [form] = Form.useForm();

  const {
    travelByOptions,
    insuredOptions,
    contentDiscriptionData,
    getContentDiscriptionData,
    getRecvNameAddressList,
    reviverNameAndAddress,
    containsAllPairs,
    allPincodes,
  } = useClientAndDepartment(userInfo, null);

  const getFocusFirstInput = (id) => {
    const timer = setTimeout(() => {
      document.getElementById(id)?.focus();
      document.getElementById(id)?.select();
    }, 100);

    return () => clearTimeout(timer);
  };

  const handlePrinting = async (payload) => {
    let currentShipment = 1;

    // Processed address fields
    const processedAddress = formatReceiverAddress(
      payload?.addressDetails?.receiverAddressLine1,
      payload?.addressDetails?.receiverAddressLine2
    );

    const receiverName = splitReceiverName(
      payload?.addressDetails?.receiverName
    );

    const serviceMap = {
      "FAST TRACK": "FST",
      STANDARD: "STD",
      "VALUE PLUS": "VPLUS",
      VAYUQUICK: "VQ",
      VAYUQUICK_PRO: "VQ PRO",
    };

    const rawService = payload?.service?.toUpperCase() || "";

    const speed = serviceMap[rawService] || rawService;

    const baseData = {
      ...receiverName,
      documentNumber: payload?.documentNumber,
      bookingType:
        payload.shipmentType?.toUpperCase() === "DOX" ? "DOX" : "NDOX",
      bookingService: speed,
      bookindTravelType:
        payload.travelBy?.toUpperCase() === "SURFACE" ? "SUR" : "AIR",
      currentShipment: currentShipment,
      senderName: payload?.clientName,
      receiverMobileNumber: payload?.addressDetails?.receiverMobileNumber,
      receiverCity: payload?.addressDetails?.receiverCity,
      deliveryPincode: payload?.addressDetails?.receiverPincode,
      receiverAddressLine1: processedAddress[0] || "",
      recieverAddressLine2: processedAddress[1] || "",
      recieverAddressLine3: processedAddress[2] || "",
      recieverAddressLine4: processedAddress[3] || "",
      recieverAddressLine5: processedAddress[4] || "",
      recieverAddressLine6: processedAddress[5] || "",
      recieverAddressLine7: processedAddress[6] || "",
      senderAddress:
        payload?.addressDetails.senderAddressLine1 +
        payload?.addressDetails.senderAddressLine1,
      senderMobileNumber: payload?.addressDetails?.senderMobileNumber || "",
      totalShipments: parseInt(payload?.childShipments?.length || "0") + 1,
    };

    const printData = async (data) => {
      try {
        const updatedTemplate = await fetch("/printingTemplate.txt")
          .then((response) => response?.text())
          .then((res) =>
            res?.replace(/{{(.*?)}}/g, (_, key) => {
              return data[key?.trim()] || "";
            })
          )
          .catch((err) => console.log(err));

        const printingData = JSON.stringify({
          device: printer,
          data: updatedTemplate,
        });
        await axios.post("http://localhost:9100/write", printingData, {
          headers: {
            "Content-Type": "text/plain",
          },
        });
      } catch (err) {
        console.log("UNABLE TO PRINT");
      }
    };

    // Print for the main payload
    const mainData = {
      ...baseData,
      documentNumber: payload?.documentNumber,
    };
    await printData(mainData);

    // Check and print for child shipments
    if (
      payload?.childShipments &&
      Array.isArray(payload?.childShipments) &&
      payload?.childShipments?.length > 0
    ) {
      for (const child of payload.childShipments) {
        currentShipment = currentShipment + 1;
        const childData = {
          ...baseData,
          documentNumber: child?.childDocumentNumber,
          currentShipment: currentShipment,
        };
        await printData(childData);
      }
    }
  };

  // Function to create address details
  const createAddressDetails = (
    bookingDetails,
    value,
    pinCodeServiceableStatus,
    reviverStateCity,
    useGoogleAddr
  ) => ({
    senderName: bookingDetails?.addressDetails?.senderName || null,
    senderCity: bookingDetails?.addressDetails?.senderCity || null,
    senderAddressLine1:
      bookingDetails?.addressDetails?.senderAddressLine1 || null,
    senderAddressLine2:
      bookingDetails?.addressDetails?.senderAddressLine2 || null,
    senderPincode: bookingDetails?.addressDetails?.senderPincode || null,
    senderState: bookingDetails?.addressDetails?.senderState || null,
    senderMobileNumber:
      bookingDetails?.addressDetails?.senderMobileNumber || null,
    senderEmail: bookingDetails?.addressDetails?.senderEmail || null,
    senderGst: bookingDetails?.addressDetails?.senderGst || null,
    areaName: bookingDetails?.addressDetails?.areaName || null,
    customerId: 0,
    receiverName: value?.receiverName || null,
    receiverAddressLine1: value?.receiverAddress || null,
    receiverAddressLine2: value?.addressLine2 || null,
    receiverCity:
      pinCodeServiceableStatus?.city || reviverStateCity?.city || null,
    receiverPincode: pinCodeServiceableStatus?.pincode || null,
    receiverState:
      pinCodeServiceableStatus?.state || reviverStateCity?.state || null,
    receiverAreaId: null,
    receiverAreaName: value?.areaId || null,
    receiverMobileNumber: +value?.mobileNumber || "0",
    receiverEmail: value?.receiverEmail || null,
    isGoogleAddress: useGoogleAddr,
  });

  // Function to create the main payload
  const createPayload = ({
    value,
    // clientDetails,
    userInfo,
    bookingDetails,
    childShipments,
    allEwayBills,
    pinCodeServiceableStatus,
    reviverStateCity,
    useGoogleAddr,
    radioActive,
    savedReturnAddressList,
    filesData,
    reviverNameAndAddress,
  }) => {
    let payload;

    const eWayBills = allEwayBills?.map((bill) => ({
      eway: bill?.ewayBillNumber,
      date: null,
      eway_bill_crt_date: bill?.ewayBillCreateDate,
      ewb_bill_exp_date: bill?.expiryDate,
      trans_mode:
        bill?.transMode?.toLowerCase() === "road"
          ? "surface"
          : bill?.transMode?.toLowerCase(),
      name: "",
    }));

    const transformedChildData = childShipments?.map((item) => ({
      documentNo: String(item?.childDocumentNumber),
      value: 0,
      dwsWeight: +item?.weight || 0,
      dwsLength: +item?.length || 0,
      dwsWidth: +item?.width || 0,
      dwsHeight: +item?.height || 0,
    }));

    const getCompanyNClient = JSON.parse(localStorage?.getItem("userinfo"));
    const userPrimiseData = JSON.parse(localStorage?.getItem("userId"));

    const getPickupAddress = () => {
      try {
        const { premises, userInfo } = userPrimiseData;

        return {
          addressType: "pickup",
          name: premises?.premiseName || null,
          email: premises?.senderEmail || null,
          gst: premises?.gst || null,
          phone: String(userInfo?.mobileNum || ""),
          address1: premises?.address || null,
          address2: null,
          landmark: premises?.senderLandmark || null,
          city: premises?.city || null,
          state: premises?.state || null,
          country: premises?.senderCountry || null,
          zip: String(premises?.pincode),
          latitude: premises?.pickupLatitude || null,
          longitude: premises?.pickupLongitude || null,
        };
      } catch (error) {
        console.error("Error fetching pickup address:", error.message);
        return null; // Return null or a default object if needed
      }
    };

    const pickup = getPickupAddress();

    payload = {
      username:
        userPrimiseData?.userInfo?.firstName +
        " " +
        userPrimiseData?.userInfo?.lastName,

      documentNo: String(value?.documentNumber) || null,
      isBulk: childShipments?.length > 0,
      bookingType: "credit",
      areaId: null,
      shipmentType: value?.shipmentType?.toUpperCase() || "DOX",
      travelBy: value?.travelBy == "SURFACE" ? "Surface" : "Air" || null,
      deliveryPromise:
        value?.service?.toLowerCase() === "fast track"
          ? "Fastrack"
          : value?.service?.toLowerCase() === "value plus"
          ? "Value Plus"
          : "Standard",
      // clientId: 953029,
      // companyId: CompId?.companyId || null,
      // clientId: 1001,

      // spId: 4970,

      companyId: getCompanyNClient?.companyId, // 10174, // pune
      clientId: getCompanyNClient?.sevasetuClientId, // 953038,

      dwsWeight: +value?.weight || 0,
      dwsLength: +value?.length || 0,
      dwsWidth: +value?.width || 0,
      dwsHeight: +value?.height || 0,

      pickupAddress: pickup,

      receiverAddress: {
        addressType: "shipping",
        name: value?.receiverName || null,
        email: value?.receiverEmail || null,
        gst: value?.receiverGst || null,
        phone: String(value?.mobileNumber || ""),
        address1: value?.receiverAddress || null,
        address2: null,
        landmark: value?.receiverLandmark || null,
        city: pinCodeServiceableStatus?.city || reviverStateCity?.city || null,
        state:
          pinCodeServiceableStatus?.state || reviverStateCity?.state || null,

        country: value?.receiverCountry || null,
        zip: String(value?.deliveryPincode),
        latitude: value?.deliveryLatitude || null,
        longitude: value?.deliveryLongitude || null,
      },

      returnAddress: {
        addressType: "return",
        ...pickup,
      },

      documents:
        filesData?.map((file) => ({
          documentLink: file?.filePath || null,
          documentType: "document" || null,
        })) || [],

      eWayBills: eWayBills || [],

      childShipments: transformedChildData || [],

      // charges: summaryData?.charges || null,
      charges: {},
      cod: null,
      pod: null,

      metadata: {
        value: +value?.value || 0,
        content: value?.content || null,
        remark: value?.remark || "",
        // insured: value?.insured?.toUpperCase() == "YES" ? true : false,
        // fov: value?.fov || false,
        // isSez: value?.isSez?.toLowerCase() === "yes" ? true : false,
        // kycDocumentNo: null,
        // kycDocumentType: null,
        // kycDocumentNo: null,
        // kycDocumentType: null,
      },
    };

    return payload;
  };

  return (
    <div>
      {!isClientAdmin ? (
        <CPCreditBooking
          printer={printer}
          contentDiscriptionData={contentDiscriptionData}
          travelByOptions={travelByOptions}
          insuredOptions={insuredOptions}
          allPincodes={allPincodes}
          getFocusFirstInput={getFocusFirstInput}
          handlePrinting={handlePrinting}
          reviverNameAndAddress={reviverNameAndAddress}

          // form={form}
        />
      ) : (
        <ClientCreditBooking
          printer={printer}
          contentDiscriptionData={contentDiscriptionData}
          travelByOptions={travelByOptions}
          insuredOptions={insuredOptions}
          allPincodes={allPincodes}
          getFocusFirstInput={getFocusFirstInput}
          handlePrinting={handlePrinting}
          getRecvNameAddressList={getRecvNameAddressList}
          reviverNameAndAddress={reviverNameAndAddress}
          createPayload={createPayload}
          // form={form}
        />
      )}
    </div>
  );
}

export default memo(CreditBookingMain);
